import { render, staticRenderFns } from "./ReviewConsultantBox.vue?vue&type=template&id=770e1f2f&lang=html&"
import script from "./ReviewConsultantBox.vue?vue&type=script&lang=coffee&"
export * from "./ReviewConsultantBox.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewConsultantBox.vue"
export default component.exports